export default __webpack_public_path__ + "static/Fly1-2c2b5359c23723bd09c3049ae48e2506.mp3";